module.exports = __webpack_public_path__ + "static/resolvedselector-65f54d3ffd85ce39727b79ac3aebaadd.png";